import React, { useCallback } from 'react'
import { Keyboard, KeyboardEventName, Platform } from 'react-native'
import { Autocomplete, AutocompleteItem } from '@ui-kitten/components'
import { BtInputLabel } from './BtInputLabel'
import { View } from 'react-native'

interface BtSearchDropdownProps {
  mandatory?: boolean
  options: string[]
  onSelect: (arg: string) => void
  value: string
  label: string
  containerStyle?: any
}

const showEvent = Platform.select({
  android: 'keyboardDidShow',
  default: 'keyboardWillShow',
})

const hideEvent = Platform.select({
  android: 'keyboardDidHide',
  default: 'keyboardWillHide',
})

const filter = (item, query): boolean =>
  item.toLowerCase().includes(query.toLowerCase())

export const BtSearchDropdown: React.FC<BtSearchDropdownProps> = (props) => {
  const {
    mandatory = false,
    options,
    onSelect,
    value,
    label,
    containerStyle,
  } = props
  const [data, setData] = React.useState(options)
  const [placement, setPlacement] = React.useState('bottom')

  React.useEffect(() => {
    const keyboardShowListener = Keyboard.addListener(
      showEvent as KeyboardEventName,
      () => {
        setPlacement('top')
      },
    )

    const keyboardHideListener = Keyboard.addListener(
      hideEvent as KeyboardEventName,
      () => {
        setPlacement('bottom')
      },
    )

    return () => {
      keyboardShowListener.remove()
      keyboardHideListener.remove()
    }
  })

  const onChangeText = useCallback(
    (query) => {
      onSelect(query)
      setData(options.filter((item) => filter(item, query)))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSelect],
  )

  const renderOption = (item, index): React.ReactElement => (
    <AutocompleteItem key={index} title={item} />
  )

  return (
    <View style={containerStyle}>
      <BtInputLabel required={mandatory}>{label}</BtInputLabel>
      <Autocomplete
        value={value}
        placement={placement}
        size="large"
        onChangeText={onChangeText}
        onSelect={(index) => onSelect(data[index])}
      >
        {data.map(renderOption)}
      </Autocomplete>
    </View>
  )
}
